import {
	NextButton,
	PrevButton,
} from '@components/carousel-buttons/carousel-buttons';
import { TeamMemberCard } from '@components/team-member-card/team-member-card';
import { TextTitle } from '@tkww/orion-web-ds-text';
import { compose } from '@xo-union/react-css-modules';
import { Carousel } from '@xo-union/ui-carousel';
import { useAtomValue } from 'jotai';
import React, { useState } from 'react';
import { teamMembersAtom } from '../../../../jotai/storefront/organization';
import type { NavItemProps } from '../nav/types';
import Style from './meet_the_team.scss';

export const MeetTheTeam = ({ className }: NavItemProps) => {
	const [carouselIndex, setCarouselIndex] = useState(0);
	const teamMembers = useAtomValue(teamMembersAtom);

	const onNavigationIndexChange = (nextIndex: number) => {
		setCarouselIndex(nextIndex);
	};

	const extraProps: { alignment?: () => string } = {};

	if (teamMembers.length === 2) {
		extraProps.alignment = () => 'left';
	}

	if (teamMembers.length > 0) {
		return (
			<div className={className}>
				<TextTitle size="sm" className={Style.title}>
					Meet the team
				</TextTitle>
				<div>
					{teamMembers.length > 1 ? (
						<Carousel
							gutter={20}
							minSlideWidth={253}
							maxSlideWidth={253}
							renderNextButton={NextButton}
							renderPrevButton={PrevButton}
							onNavigationIndexChange={onNavigationIndexChange}
							navigationIndex={carouselIndex}
							classes={compose({
								slidesList: Style.slideList,
								rightButtonContainer: Style.buttonContainer,
								leftButtonContainer: Style.buttonContainer,
							})}
							{...extraProps}
						>
							{teamMembers.map((member) => (
								<TeamMemberCard
									key={`card_${member.name}`}
									isReduced={true}
									memberBio={member}
								/>
							))}
						</Carousel>
					) : (
						<TeamMemberCard memberBio={teamMembers[0]} />
					)}
				</div>
			</div>
		);
	}

	return null;
};
